// extracted by mini-css-extract-plugin
export default {"anchor":"styles__anchor___ImRgp"};